"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var RadarChart = /** @class */ (function (_super) {
    __extends(RadarChart, _super);
    function RadarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadarChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_maxValue":
            case "_radius":
            case "_labelFactor":
                return utils_1.parseNumberWithAuto(value);
            case "_isRound":
            case "_isRadical":
                return utils_1.parseBoolean(value);
            case "_valueFunc":
            case "_categoryFunc":
            case "_axesFunc":
            case "_axisFunc":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    RadarChart.prototype.defaultOptions = function () {
        return {
            _maxValue: -1,
            _radius: 2.5,
            _labelFactor: 1.2,
            _isRound: false,
            _isRadical: true,
            _axesFunc: function (d) { return d.axes; },
            _axisFunc: function (d) { return d.axis; },
            _valueFunc: function (d) { return d.value; },
            _categoryFunc: function (d) { return d.className; },
        };
    };
    RadarChart.prototype.init = function () {
        var _this = this;
        this.scale = d3.scaleLinear();
        this._toolTip = __1.tooltip.create("pointtip");
        this._groupRadiuses = this.appendGroupT(_1.Component).data([])
            .options({
            _x: function (d) { return _this._radius; },
            _y: function (d) { return _this._radius; },
        });
        this._radiusLines = this._groupRadiuses.appendT(element_1.Line)
            .options({
            x1: function (d) { return 0; },
            y1: function (d) { return 0; },
            x2: function (d) { return d.xLine; },
            y2: function (d) { return d.yLine; },
        });
        // FIXME: text still exceeds the bounding box
        this._radiusLabels = this._groupRadiuses.appendT(element_1.Text)
            .options({
            _x: function (d) { return d.xText; },
            _y: function (d) { return d.yText; },
            _text: function (d) { return d.axis; },
            _anchor: this._getAnchor(),
        });
        this._bgCircles = this.appendGroupT(element_1.Circle).data([]).options({
            _r: function (d) { return d; },
            _x: function (d) { return _this._radius; },
            _y: function (d) { return _this._radius; },
            fill: "none",
            visibility: function (d) { return _this.getOption("_isRound") ? "visible" : "hidden"; },
        });
        this._bgPolygon = this.appendGroupT(element_1.Line).data([]).options({
            _x: function (d) { return 0; },
            _y: function (d) { return 0; },
            x1: function (d) { return d.x1; },
            x2: function (d) { return d.x2; },
            y1: function (d) { return d.y1; },
            y2: function (d) { return d.y2; },
            visibility: function (d) { return !_this.getOption("_isRound") ? "visible" : "hidden"; },
        });
        this._lines = this.appendGroupT(element_1.Path).data([]).options({
            _x: function (d) { return 0; },
            _y: function (d) { return 0; },
            d: function (d) { return d.path; },
            opacity: 0.5,
            _$mouseEnter: function (d, i, g) {
                g.forEach(function (el, j) {
                    if (j === i) {
                        g[j].style.opacity = "0.7";
                    }
                    else {
                        g[j].style.opacity = "0.2";
                    }
                });
            },
            _$mouseLeave: function (d, i, g) {
                g.forEach(function (el, j) {
                    g[j].style.opacity = "0.3";
                });
            },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._lines.dom)
                    .renderHTML(function (d) { return d.className; });
            },
        });
        this._pointGroups = this.appendGroupT(_1.Component).data([]).options({});
        this._points = this._pointGroups.appendGroupT(element_1.Circle).data([])
            .options({
            _data: function (d) { return d; },
            _x: function (d) { return d.x; },
            _y: function (d) { return d.y; },
            _r: function (d) { return _this.getOption("_radius"); },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._points.dom)
                    .renderHTML(function (d, i) { return "" + d.value; });
            },
        });
    };
    RadarChart.prototype.prepare = function () {
        var _this = this;
        var height = this._getGeometry("_height", false);
        var width = this._getGeometry("_width", true);
        this._axesFunc = this.getOption("_axesFunc");
        this._axisFunc = this.getOption("_axisFunc");
        this._valueFunc = this.getOption("_valueFunc");
        this._categoryFunc = this.getOption("_categoryFunc");
        var allAxis = this._axesFunc(this.datum[0]).map(this._axisFunc);
        var totalAxis = allAxis.length;
        var angleSlice = Math.PI * 2 / totalAxis;
        this._radius = Math.min(height / 2, width / 2);
        var maxValue = this._getMaxValue();
        this.scale = d3.scaleLinear()
            .range([0, this._radius / this.getOption("_labelFactor")])
            .domain([0, maxValue])
            .nice(5);
        // Generate path data and point data
        var pathData = [];
        var pointData = [];
        this.datum.forEach(function (area) {
            var path = "";
            var className = _this._categoryFunc(area);
            var points = _this._axesFunc(area).map(function (o, i) {
                var value = _this._valueFunc(o);
                var angle = angleSlice * i - Math.PI / 2;
                var radius = _this.scale(value);
                var x = radius * Math.cos(angle) + _this._radius;
                var y = radius * Math.sin(angle) + _this._radius;
                // Line
                path += i === 0 ? "M" + x + "," + y : "L" + x + "," + y;
                // Point
                return { x: x, y: y, className: className, value: value };
            });
            pathData.push({ className: className, path: path });
            pointData.push(points);
        });
        this._lines.data(pathData);
        this._pointGroups.data(pointData);
        // Generate radiusLine, radiusLable data
        var radiusData = allAxis.map(function (s, i) {
            var angle = angleSlice * i - Math.PI / 2;
            var cos = Math.cos(angle);
            var sin = Math.sin(angle);
            var linerRadius = d3.max(_this.scale.domain());
            var textRadius = linerRadius * _this.getOption("_labelFactor");
            var cachedLineRadius = _this.scale(linerRadius);
            var cachedTextRadius = _this.scale(textRadius);
            return {
                xLine: cachedLineRadius * cos,
                yLine: cachedLineRadius * sin,
                xText: cachedTextRadius * cos,
                yText: cachedTextRadius * sin,
                axis: s,
            };
        });
        this._groupRadiuses.data(radiusData);
        // Generate bgCircle data
        this._bgCircles.data(this.scale.ticks(5).map(function (d) { return _this.scale(d); }));
        // Generate bgPolygon data
        var bgPolygonData = [];
        this.scale.ticks(5).forEach(function (d) {
            var radius = _this.scale(d);
            allAxis.forEach(function (o, i) {
                var angle1 = angleSlice * i - Math.PI / 2;
                var angle2 = angleSlice * (i + 1) - Math.PI / 2;
                bgPolygonData.push({
                    x1: radius * Math.cos(angle1) + _this._radius,
                    y1: radius * Math.sin(angle1) + _this._radius,
                    x2: radius * Math.cos(angle2) + _this._radius,
                    y2: radius * Math.sin(angle2) + _this._radius,
                });
            });
        });
        this._bgPolygon.data(bgPolygonData);
        this.setupProxy({
            axis: function (axis) {
                axis.options({
                    _tickCount: _this.scale.ticks(5).length,
                    _scale: _this.scale,
                    _gravity: __1.Gravity.Left,
                    _x: _this._radius,
                });
            },
            point: "_points",
            area: "_lines",
            bg: this.getOption("_isRound") ? "_bgCircles" : "_bgPolygon",
            line: "_radiusLines",
            label: "_radiusLabels",
        });
    };
    RadarChart.prototype._getMaxValue = function () {
        var _this = this;
        var max = d3.max(this.datum.map(function (o) { return d3.max(_this._axesFunc(o), _this._valueFunc); }));
        return this.getOption("_maxValue") < max ? max : this.getOption("_maxValue");
    };
    RadarChart.prototype._getAnchor = function () {
        return function (d) {
            var anchorX;
            var anchorY;
            if (Math.round(d.xText) > 0) {
                anchorX = 16 /* Left */;
            }
            else if (Math.round(d.xText) < 0) {
                anchorX = 64 /* Right */;
            }
            else {
                anchorX = 32 /* Center */;
            }
            if (Math.round(d.yText) > 0) {
                anchorY = 2 /* Top */;
            }
            else if (Math.round(d.yText) < 0) {
                anchorY = 8 /* Bottom */;
            }
            else {
                anchorY = 4 /* Middle */;
            }
            return anchorX | anchorY;
        };
    };
    return RadarChart;
}(_1.Component));
exports.RadarChart = RadarChart;
//# sourceMappingURL=radar-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/radar-chart.js
// module id = 1147
// module chunks = 0 1